import { CLEAR_LOCATION, LOCATION_SHOW_DEBUG, SET_LOCATION } from 'src/app/state/actions/types';

export function setLocationAction(location) {
  return {
    type: SET_LOCATION,
    location,
  };
}

export function showLocationDebugAction(value) {
  return {
    type: LOCATION_SHOW_DEBUG,
    value,
  };
}

export function clearLocationAction() {
  return {
    type: CLEAR_LOCATION,
  };
}
